export enum SubSectionHeaderType {
  REINSURERS = 'REINSURERS',
  REINSURERS_WITH_YEAR = 'REINSURERS_WITH_YEAR',
  REINSURERS_RECOVERABLE_FIRST = 'REINSURERS_RECOVERABLE_FIRST',
  REINSURERS_LIFE_CEDED = 'REINSURERS_LIFE_CEDED',
  REINSURERS_AH_CEDED = 'REINSURERS_AH_CEDED',
  REINSURERS_LIFE_ASSUMED = 'REINSURERS_LIFE_ASSUMED',
  REINSURERS_AH_ASSUMED = 'REINSURERS_AH_ASSUMED',
  CURRENT_YEAR_ONLY = 'CURRENT_YEAR_ONLY',
  LOSSES_PAID = 'LOSSES_PAID',
  LOSSES_INCURRED_AND_RATIO = 'LOSSES_INCURRED_AND_RATIO'
}
